/* src/app/features/purchase-requests/supplier-selection/supplier-email/supplier-email.component.css */
/*# sourceMappingURL=supplier-email.component.css.map */
